namespace AgerLMS.CMS {
    export interface SliderRow {
        SliderId?: number;
        SliderName?: string;
        SliderType?: SliderTypes;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace SliderRow {
        export const idProperty = 'SliderId';
        export const nameProperty = 'SliderName';
        export const localTextPrefix = 'CMS.Slider';
        export const deletePermission = 'LMS:CmsPage:Modify';
        export const insertPermission = 'LMS:CmsPage:Modify';
        export const readPermission = 'CMS:Slider:Read';
        export const updatePermission = 'LMS:CmsPage:Modify';

        export declare const enum Fields {
            SliderId = "SliderId",
            SliderName = "SliderName",
            SliderType = "SliderType",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
